import { render, staticRenderFns } from "./VsInput.vue?vue&type=template&id=3f83c8ca&scoped=true&"
import script from "./VsInput.vue?vue&type=script&lang=js&"
export * from "./VsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f83c8ca",
  null
  
)

export default component.exports